import "../../../styles/CounterField.scss";

import Icon, {iconColor, iconTypes} from "./Icon.jsx"; 

import PropTypes from "prop-types";
import React from "react";

export default class AddRemoveField extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            focused: false,
            value: this.props.value || 0,
            recivedValue: this.props.value || 0,
            version: this.props.version || -1,
        };

        this.onChange = this.onChange.bind(this);
        this.onSetValue = this.onSetValue.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.getClassName = this.getClassName.bind(this);

        this.onClickAdd = this.onClickAdd.bind(this);
        this.onClickRemove = this.onClickRemove.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if( (nextProps.version==null || nextProps.version!==this.state.version)  && nextProps.value!==this.state.recivedValue ){
            this.setState({
                value: nextProps.value,
                recivedValue: nextProps.value,
                version: nextProps.version,
            });
        }
    }

    onChange(event) {
        const newValStr = event.target.value.replace(/\D/,"");
        const parsedValue = parseInt(newValStr);

        this.onSetValue(parsedValue>=1?parsedValue:0);
    }
    onFocus() {
        this.setState({ focused: true });
    }
    onBlur() {
        this.setState({ focused: false });
        //
        this.onSetValue(this.state.value);
    }
    onSetValue(newValue) {
        const currentValue = this.state.value;
        const setValue = newValue>=1 ? newValue : 0;
        if(setValue !== currentValue) {
            this.setState({
                value: setValue,
            });
        }
    }
    getClassName() {
        const {
            isValid
        } = this.props;

        let className = "input-text";
        if(!this.state.focused){
            if(isValid===false){
                className += " error";
            }else if(isValid===true){
                className += " is-valid";
            }
        }
        return className;
    }

    onClickAdd(event) {
        event.stopPropagation();
        event.preventDefault();
        
        this.props.onEdit({
            diff: 1,
            value: 1,
        });
        this.setState({
            value: 1,
        });
    }
    onClickRemove(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.onEdit({
            diff: -1,
            value: 0,
        });
        this.setState({
            value: 0,
        });
    }

    render() {
        const {
            disabled,
        } = this.props;

        const iconPlusStyle = {
            left: "calc(100% - 42px)"
        };

        return this.state.value ? (
            <button className={"btn circular noselect"} onClick={this.onClickRemove} style={iconPlusStyle}>
                <Icon type={iconTypes.x} color={iconColor.red} opacity={disabled?0.5:undefined}/>
            </button>
        ) : (
            <button className={"btn circular noselect"} onClick={this.onClickAdd} style={iconPlusStyle}>
                <Icon type={iconTypes.plus} color={iconColor.red} opacity={disabled?0.5:undefined}/>
            </button>
        );
    }
}

AddRemoveField.propTypes = {
    // Mandatory
    onEdit: PropTypes.func,  // onEdit(change)
    value: PropTypes.number,
    //to check if the value has been changed
    version: PropTypes.number,
    // Optional
    maxLength: PropTypes.number,
    disabled: PropTypes.bool,
    isValid: PropTypes.bool,
    spellcheck: PropTypes.bool,
    placeholder: PropTypes.string,
    tabIndex: PropTypes.number,
    usingSubmit: PropTypes.bool,
    className: PropTypes.string,
    border: PropTypes.bool,
};

AddRemoveField.defaultProps = {
    disabled: false,
    isValid: null,
    usingIcon: undefined,
    usingSubmit: false,
    border: true,
};